var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { XIcon, XLoader } from '../../ui';
import { Touchable } from './Touchable';
export function Button(input) {
    var color = input.color, _a = input.variant, variant = _a === void 0 ? 'filled' : _a, icon = input.icon, iconStart = input.iconStart, iconEnd = input.iconEnd, fullWidth = input.fullWidth, className = input.className, isLoading = input.isLoading, rest = __rest(input, ["color", "variant", "icon", "iconStart", "iconEnd", "fullWidth", "className", "isLoading"]);
    if (isLoading) {
        rest.disabled = true;
    }
    iconStart = icon || iconStart;
    var iconOnly = Boolean(!input.children && (iconStart || iconEnd));
    var buttonInput = __assign({ className: clsx(className, 'XR-Button', {
            iconOnly: iconOnly,
            iconStart: iconStart,
            iconEnd: iconEnd,
            hasContent: input.children,
            fullWidth: fullWidth,
        }) }, rest);
    return (React.createElement(Touchable, __assign({ variant: variant, color: color }, buttonInput, { as: 'button' }),
        iconStart && React.createElement(XIcon, { className: 'icon-start' }, iconStart),
        input.children,
        iconEnd && React.createElement(XIcon, { className: 'icon-end' }, iconEnd),
        isLoading && React.createElement(XLoader, { className: 'loader' })));
}
